// Concatena nome da variação + tamanho + cor com hifens, ignorando partes
// vazias para não vazar separadores. Ex.: "Camiseta – M – Azul",
// "Camiseta – M" (sem cor), "Camiseta" (sem tamanho/cor).
//
// Aceita tanto a forma flat (variação editada localmente: { name, size, color })
// quanto a forma persistida pela API (size/color em attributes).
export function formatVariationLabel(v) {
  if (!v) return '';
  const size = v.size || v.attributes?.size || '';
  const color = v.color || v.attributes?.color || '';
  const parts = [v.name, size, color]
    .map((p) => (p == null ? '' : String(p).trim()))
    .filter(Boolean);
  return parts.length ? parts.join(' – ') : '(sem identificação)';
}
